import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Link } from "react-router";

type Variant = "primary" | "ghost";

const base =
  "group relative inline-flex items-center justify-center gap-2 overflow-hidden px-9 py-3.5 text-[0.72rem] uppercase tracking-[0.22em] font-medium transition-all duration-500 disabled:opacity-50 disabled:cursor-not-allowed";

const variants: Record<Variant, string> = {
  primary:
    "bg-[var(--color-emerald-deep)] text-[var(--color-cream)] hover:bg-[var(--color-emerald)] shadow-[inset_0_0_0_1px_rgba(212,175,55,0.25)] hover:shadow-[inset_0_0_0_1px_rgba(212,175,55,0.6),0_8px_30px_-12px_rgba(15,71,49,0.6)]",
  ghost:
    "border border-[var(--color-emerald)]/50 text-[var(--color-emerald-deep)] hover:border-[var(--color-gold)] hover:text-[var(--color-emerald)]",
};

type CommonProps = {
  variant?: Variant;
  children: ReactNode;
  className?: string;
};

type ButtonProps = CommonProps & ButtonHTMLAttributes<HTMLButtonElement>;
type LinkProps = CommonProps & { to: string };

function GoldSweep() {
  return (
    <span
      aria-hidden
      className="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-[var(--color-gold)]/25 to-transparent transition-transform duration-700 group-hover:translate-x-full"
    />
  );
}

export function Button({
  variant = "primary",
  className = "",
  children,
  ...props
}: ButtonProps) {
  return (
    <button
      className={`${base} ${variants[variant]} ${className}`}
      {...props}
    >
      <GoldSweep />
      <span className="relative">{children}</span>
    </button>
  );
}

export function ButtonLink({
  variant = "primary",
  className = "",
  children,
  to,
}: LinkProps) {
  return (
    <Link to={to} className={`${base} ${variants[variant]} ${className}`}>
      <GoldSweep />
      <span className="relative">{children}</span>
    </Link>
  );
}
